export default "__VITE_ASSET__CCN6x2YI__"